import { render } from "./SearchBar.vue?vue&type=template&id=60fe6d82&scoped=true&bindings={\"selectedBook\":\"data\",\"selectedTome\":\"data\",\"selectedEpisode\":\"data\",\"search\":\"data\",\"leodagan\":\"data\",\"orderBy\":\"data\",\"sortAsc\":\"data\",\"episodes\":\"options\",\"availableSorts\":\"options\",\"raz\":\"options\",\"updateOrder\":\"options\",\"updateEpisode\":\"options\",\"updateSearch\":\"options\",\"trans\":\"options\",\"trans_episode\":\"options\",\"store\":\"setup\"}"
import script from "./SearchBar.vue?vue&type=script&lang=js"
export * from "./SearchBar.vue?vue&type=script&lang=js"

import "./SearchBar.vue?vue&type=style&index=0&id=60fe6d82&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-60fe6d82"

export default script